import React from "react";


export const ExeSort = (props) => {
    const { excsInfo, settingExeIdx } = props;

    return (
        <div>
            <div className="inly-sutit">운동 종류</div>

            <div>
                <div className="select-custom-box in5 weight-set">
                    <a className="btn-select inb">걷기</a>
                    <ul>
                        {excsInfo.map((m, i) => (
                            <li key={"label" + i} onClick={()=>settingExeIdx(i, m.code)}><a>{m.label}</a></li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};
